module.exports = __webpack_public_path__ + "img/gift.a8e913a6.png";